import React from 'react';
import { Typography, Box, Button, IconButton, List, ListItem, ListItemText } from '@mui/material';
import { AttachFile, Delete, Add } from '@mui/icons-material';
import getApiUrl from '../../utils/apiUrl';

const ProjectAttachments = ({ 
  projectData, 
  fileInputRef, 
  onFileSelect, 
  onDeleteAttachment 
}) => {
  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
        <Typography variant="body1" sx={{ fontWeight: 600 }}>Attachments:</Typography>
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: 'none' }}
          multiple
          accept=".png,.jpg,.jpeg,.pdf,.dwg,.svg"
          onChange={(e) => onFileSelect(e.target.files)}
        />
        <Button
          startIcon={<Add />}
          onClick={() => fileInputRef.current?.click()}
          size="small"
          variant="outlined"
        >
          Add Files
        </Button>
      </Box>
      {projectData.attachments && projectData.attachments.length > 0 ? (
        <List dense sx={{ maxHeight: 200, overflow: 'auto' }}>
          {projectData.attachments.map((attachment) => (
            <ListItem 
              key={attachment.id} 
              sx={{ px: 0, pr: 5 }}
              secondaryAction={
                <IconButton
                  edge="end"
                  size="small"
                  onClick={() => onDeleteAttachment(attachment)}
                >
                  <Delete fontSize="small" />
                </IconButton>
              }
            >
              <AttachFile fontSize="small" sx={{ mr: 1 }} />
              <ListItemText
                primary={
                  <a
                    href={`${getApiUrl()}${attachment.url}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    {attachment.data_file_name}
                  </a>
                }
                primaryTypographyProps={{ variant: 'body2' }}
              />
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography variant="body2" color="text.secondary">
          No attachments
        </Typography>
      )}
    </Box>
  );
};

export default ProjectAttachments;
